<template>
  <v-card>
    <v-card-title>
      {{ $t("Top.todos") }}
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-list nav dense>
        <v-list-group color="sidebarActive" class="mb-1">
          <template v-slot:activator>
            <v-list-item-content class="me-n16">
              <v-list-item-title class="me-n16">
                <v-row no-gutters>
                  <v-col>
                    {{ $t("Delivery.ObjectName") }}
                  </v-col>
                  <v-spacer />
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <span v-if="!deliveryFlg">
            <v-list-item color="sidebarActive">
              <v-list-item-content>
                <v-list-item-title class="ms-4 me-n14">
                  <v-row no-gutters>
                    <v-col>
                      {{ $t("Delivery.Status.on") }}
                    </v-col>
                    <v-spacer />
                    <v-col class="text-end me-16 pe-14">{{
                      todos ? todos.purchase_delivery_count : "-"
                    }}</v-col>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item color="sidebarActive">
              <v-list-item-content>
                <v-list-item-title class="ms-4 me-n14">
                  <v-row no-gutters>
                    <v-col>
                      {{ $t("Delivery.Status.off") }}
                    </v-col>
                    <v-spacer />
                    <v-col class="text-end me-16 pe-14">{{
                      todos ? todos.purchase_no_delivery_count : "-"
                    }}</v-col>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </span>
          <span v-else>
            <v-list-item color="sidebarActive">
              <v-list-item-content>
                <v-list-item-title class="ms-4 me-n14">
                  <v-row no-gutters>
                    <v-col>
                      {{ $t("Delivery.ObjectName") }}
                    </v-col>
                    <v-spacer />
                    <v-col class="text-end me-16 pe-14">{{
                      todos ? todos.purchase_all_count : "-"
                    }}</v-col>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </span>
        </v-list-group>
        <v-list-group color="sidebarActive" class="mb-1">
          <template v-slot:activator>
            <v-list-item-content class="me-n16">
              <v-list-item-title class="me-n16">
                <v-row no-gutters>
                  <v-col>
                    {{ $t("StockOuts.ObjectName") }}
                  </v-col>
                  <v-spacer />
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item color="sidebarActive">
            <v-list-item-content>
              <v-list-item-title class="ms-4 me-n14">
                <v-row no-gutters>
                  <v-col>
                    {{ $t("StockOuts.ObjectName") }}
                  </v-col>
                  <v-spacer />
                  <v-col class="text-end me-16 pe-14">{{
                    returnTodos ? returnTodos.count : "-"
                  }}</v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ToDos",

  props: {
    todos: Object,
    returnTodos: Object,
  },

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    deliveryFlg() {
      if (
        this.accountUser &&
        this.accountUser.supplier &&
        this.accountUser.supplier.delivery_flg == 0
      ) {
        return true;
      }
    },
    ...mapState(["accountUser"]),
  },
};
</script>
